import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Form, Row, Col, Accordion } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import { CSVLink } from "react-csv";
import moment from "moment";
import mail from "../../assets/images/icon/mail.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import cross from "../../assets/images/icon/cross.svg";

import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import { Trans, useTranslation } from "react-i18next";

import {
  GetCompetencyCategoryList,
  DeleteRecords,
  getFilteredList,
} from "../../services/CompetencyCategoryService";
import { FetchFilterInfo } from "../../services/pendingService";
import {
  checkPermissionStatus,
  getCompanyTimezoneDateTime,
} from "helpers/utils";
import { decryptDataFromArray } from "helpers/EncDec";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";

const CompetencyCategoryList = () => {
  const { t } = useTranslation();
  const [competencyCategoryList, setCompetencyCategoryList] = useState([]);
  const [query, setQuery] = useState("");
  const [csvData, setCSVData] = useState([]);
  const companyId = localStorage.getItem("subdomainId");
  const [isVisible, setIsVisible] = useState(false);
  const [jobTitleTypes, setJobTitleTypes] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [vacancytype, setvacancytype] = useState([]);
  const [vacancy, setvacancy] = useState("");
  const [roundsData, setroundsData] = useState([]);
  const [rounds, setrounds] = useState("");
    const tableWrapperRef = useRef(null);
  const [lang_id, setLangId] = useState(() => {
    // Retrieve the lang_id from localStorage or set it to "1" if it doesn't exist or equals 1
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });

    useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
  };

  const handleSubmit = () => {
    let payload = {
      rounds: rounds,
      vacancy: vacancy,
      jobTitle: jobTitle,
    };
    getFilteredList(payload)
      .then(res => {
        if (res.data.status) {
          setCompetencyCategoryList(res?.data?.data);
        } else {
          toast.error("No data available");
        }
        close();
      })
      .catch(err => console.log(err));
  };

  const clearFilters = () => {
    setJobTitle("");
    setvacancy("");
  };
  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data?.data || "";
        if (filterData) {
          console.log(filterData?.roles, "roles");
          setJobTitleTypes(filterData?.roles || []);
          setvacancytype(filterData?.vacancytype || []);
          setroundsData(filterData?.rounds || []);
          getCompetencyList(filterData?.roles || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  useEffect(() => {
    getFilterInfo();

    document.title = t(`NeuroTal - Competency Category List`);
  }, []);

  const getCompetencyList = async jobList => {
    console.log(lang_id, "lang_id");
    await GetCompetencyCategoryList(lang_id)
      .then(res => {
        let responseData = res?.data;
        // console.log(responseData, "responseData");

        responseData = decryptDataFromArray(responseData);
        // console.log(JSON.stringify(responseData), "responseData");
        if (responseData?.status) {
          let comptData =
            responseData?.data?.map(el => {
              let jobTitles = [];
              // console.log(JSON.stringify(jobList), "jobList");
              jobList?.map(item => {
                if (el?.job_title?.includes(item?.value)) {
                  jobTitles.push(item?.label);
                }
              });
              jobTitles = jobTitles?.join(", ") || "";
              return {
                ...el,
                jobTitles: jobTitles,
              };
            }) || [];

          setCompetencyCategoryList(comptData);
        }
      })
      .catch(err => {});
  };

  const handleDeleteRecords = id => {
    DeleteRecords(id)
      .then(res => {
        if (res?.status === 200) {
          window.location.reload();
        } else {
          console.error("Delete record failed:", res?.data?.message);
        }
      })
      .catch(error => {
        console.error("Error deleting record:", error);
      });
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`mcq_manager.Showing rows`)} {from} {t(`mcq_manager.to`)} {to}{" "}
      {t(`mcq_manager.of`)} {size}
    </span>
  );

  //Handle CSV

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = competencyCategoryList?.filter(renderCheck);
    setCSVData(data);
    setTimeout(() => {
      let element = document.getElementById("downloadCSV");
      element.click();
    }, 1000);
  };

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle:"First page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  let columns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "name",
      text: t(`mcq_manager.Competency Category`),
    },
    {
      dataField: "Company.company_name",
      text: "Company Name",
      hidden: companyId, // Hide the column if companyId exist
    },
    {
      dataField: "VacancyType.title",
      text: t(`mcq_manager.Vacancy Type`),
    },
    {
      dataField: "jobTitles",
      text: t(`mcq_manager.Positions`),
    },
    {
      dataField: "InterviewTitle.interview_title",
      text: t(`mcq_manager.Rounds`),
    },
    {
      dataField: "ques_count",
      text: t(`mcq_manager.Question Count`),
    },
    {
      dataField: "duration",
      text: t(`mcq_manager.Duration`),
    },
    {
      dataField: "createdAt",
      text: t(`mcq_manager.Created At`),
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format("DD MMM YYYY");
      },
    },
    {
      dataField: "status",
      text: t(`mcq_manager.Status`),
      formatter: (cellContent, row) => (
        <>
          {row?.status == "1"
            ? t(`mcq_manager.Active`)
            : t(`mcq_manager.In Active`)}
        </>
      ),
    },
  ];

  if (checkPermissionStatus("competency-category-list", "edit")) {
    columns.push({
      dataField: "",
      text: t(`mcq_manager.Actions`),
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-competency-category/${row.id}`}
                title="Edit Competency Category"
              >
                <img src={edit_icon} alt="edit_icon" />
                <span> {t(`mcq_manager.Edit Competency Category`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                onClick={() => handleDeleteRecords(row.id)}
                className="text-success blue-icon blue-color3"
                style={{ cursor: "pointer" }}
                to="#"
                title="Delete Record"
              >
                <img src={delete_icon} alt="delete_icon" />
                <span> {t(`mcq_manager.Delete`)}</span>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  const renderCheck = item => {
    const searchableText = (
      item?.name +
      item?.slug +
      item?.sequence +
      moment(getCompanyTimezoneDateTime(item?.createdAt)).format(
        "DD MMM YYYY"
      ) +
      (item?.status === "1"
        ? t(`mcq_manager.Active`)
        : t(`mcq_manager.In Active`))
    ).toLowerCase();
    return searchableText.includes(query.toLowerCase());
  };

  if (!checkPermissionStatus("competency-category-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  /**table arrow */

  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };



  return (
    <>
      <div className="pending-list-page feedbacks departmentpage">
        <div className="tab-content" id="pills-tabContent">
          <div className="joblist-container create-vacancy main-pages-s">
            <Row className="mb-2 align-items-center">
              <Col lg="6" md="6" className="Joblist-column">
                <Link to="/dashboard">
                  <h5 className="text-uppercase heading-one">
                    <img src={arrow_btn} alt="arrow_btn" />
                    {t(`mcq_manager.Configure Competency List`)}
                  </h5>
                </Link>
              </Col>
            </Row>
          </div>

          {/* <div className="outerTab-box-wrapper below-vacancy  amsterresign  applicationcard-table"> */}
          <div className="outerTab-box-wrapper applicationcard-table">
            <div className="franchise-list-page region-list-page aploc">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                jobTitle="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-application table-responsive pb-3">
                  <div className="table-data-search">
                    <div className="total-record">
                      <h5>
                        {t(`mcq_manager.Total Records`)}:{" "}
                        <span>{competencyCategoryList?.length || 0}</span>
                      </h5>
                    </div>
                    <div className="total-serachbar">
                      <div className="serach-bar-top">
                        <form class="form-inline">
                          <input
                            class="form-control mr-sm-2"
                            type="search"
                            placeholder={t(
                              `mcq_manager.Search by name, description`
                            )}
                            aria-label="Search"
                            onChange={e => setQuery(e.target.value)}
                            title={t(`mcq_manager.Search by name, description`)}
                          />
                          <span>
                            <img src={serach_icon} alt="search" />
                          </span>
                        </form>
                      </div>
                      {checkPermissionStatus(
                        "competency-category-list",
                        "downloadcsv"
                      ) && (
                        <div className="take-text">
                          <CSVLink
                            data={csvData}
                            headers={[
                              {
                                key: "id",
                                label: t(`mcq_manager.S No`),
                              },
                              {
                                key: "name",
                                label: t(`mcq_manager.Competency Category`),
                              },
                              {
                                key: "VacancyType.title",
                                label: t(`mcq_manager.Vacancy Type`),
                              },
                              {
                                key: "jobTitles",
                                label: t(`mcq_manager.Postitions`),
                              },
                              {
                                key: "InterviewTitle.interview_title",
                                label: t(`mcq_manager.Rounds`),
                              },
                              {
                                key: "ques_count",
                                label: t(`mcq_manager.Question Count`),
                              },
                              {
                                key: "duration",
                                label: t(`mcq_manager.Duration`),
                              },
                              {
                                key: "status",
                                label: t(`mcq_manager.Status`),
                              },
                              {
                                key: "createdAt",
                                label: t(`mcq_manager.Created Date`),
                              },
                            ]}
                            filename={`t(mcq_manager.Competency).csv`}
                            id="downloadCSV"
                          >
                            <Button
                              color="info"
                              onClick={e => handleCSVDownload(e)}
                              outline
                            >
                              <img src={dowanload_csv} alt="Download" />{" "}
                              {t(`mcq_manager.Download CSV`)}
                            </Button>
                          </CSVLink>
                        </div>
                      )}
                      <div className="take-text filter" onClick={filter_icon}>
                        <h5>
                          <span>
                            <img src={filtericon} alt="" />
                          </span>
                          {t(`mcq_manager.Filters`)}
                        </h5>
                      </div>
                      {checkPermissionStatus(
                        "competency-category-list",
                        "create"
                      ) && (
                        <div className="take-text filter">
                          <Link
                            to="/create-competency-category"
                            className="btn btn-primary"
                          >
                            + {t(`mcq_manager.Create`)}
                          </Link>
                        </div>
                      )}

                      <div className="tale-text right-panel">
                        <button
                          className="button left"
                          onClick={() => handleScroll("left")}
                          data-tooltip="Scroll Left"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                        <button
                          className="button right"
                          onClick={() => handleScroll("right")}
                          data-tooltip="Scroll Right"
                        >
                          <img src={right_arrow} alt="right-arrow" />
                        </button>
                      </div>
                    </div>
                  </div>
                  {isVisible && (
                    <div className="filter-shadow filetr-cards">
                      <div className="filters-cards">
                        <div className="filters-cards-cross">
                          <div className="filter-content">
                            <h4>{t(`mcq_manager.Filters`)}</h4>
                          </div>
                          <div className="filter-content cross" onClick={close}>
                            <img src={cross} alt="" />
                          </div>
                        </div>
                        <div className="bordertops"></div>
                        <div className="filter-cards-form pt-4">
                          <form class="form-inline">
                            <div className="col-lg-12">
                              <div
                                title={`${
                                  vacancy
                                    ? vacancytype.find(
                                        el => el.value == vacancy
                                      )?.label
                                    : t("Select Vacancy Type")
                                }`}
                              >
                                <Form.Select
                                  onChange={e => setvacancy(e.target.value)}
                                  aria-label="Default select example"
                                  value={vacancy}
                                >
                                  <option value="">Select Position Level</option>
                                  {vacancytype?.map(el => {
                                    return (
                                      <option value={el?.value}>
                                        {el?.label}
                                      </option>
                                    );
                                  })}
                                </Form.Select>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div
                                title={`${
                                  jobTitle
                                    ? jobTitleTypes.find(
                                        el => el.value == jobTitle
                                      )?.label
                                    : t("Select Job title")
                                }`}
                              >
                                <Form.Select
                                  onChange={e => setJobTitle(e.target.value)}
                                  aria-label="Default select example"
                                  value={jobTitle}
                                >
                                  <option value="">Select Job title</option>
                                  {jobTitleTypes?.map(el => {
                                    return (
                                      <option value={el?.value}>
                                        {el?.label}
                                      </option>
                                    );
                                  })}
                                </Form.Select>
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div
                                title={`${
                                  rounds
                                    ? roundsData.find(el => el.value == rounds)
                                        ?.label
                                    : t("Select Rounds")
                                }`}
                              >
                                <Form.Select
                                  onChange={e => setrounds(e.target.value)}
                                  aria-label="Default select example"
                                  value={rounds}
                                >
                                  <option value="">Select Rounds</option>
                                  {roundsData?.map(el => {
                                    return (
                                      <option value={el?.value}>
                                        {el?.label}
                                      </option>
                                    );
                                  })}
                                </Form.Select>
                              </div>
                            </div>
                          </form>
                          <div className="col-lg-12">
                            <div className="serach-btn">
                              <button
                                className="btn btn-primary reset"
                                onClick={() => clearFilters()}
                              >
                                Reset
                              </button>
                              <button
                                className="btn btn-primary search"
                                onClick={() => handleSubmit()}
                              >
                                Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div className="timeto-hire-card userlist allapplication-po"> */}
                  <div className="timeto-hire-card userlist pendiglist-cardss">
                    <div className="table-custome-class range-custome">
                      <>
                        <div className="scroll-container">
                          <div className="table-pending-list">
                            <div
                              className="table-wrapper"
                              ref={tableWrapperRef}
                            >
                              <BootstrapTable
                                keyField="id"
                                data={competencyCategoryList?.filter(
                                  renderCheck
                                )}
                                columns={columns}
                                pagination={paginationFactory(options)}
                                rowClasses={rowClasses}
                                hover
                                responsive
                              />
                            </div>
                          </div>
                        </div>
                      </>
                      {competencyCategoryList?.filter(renderCheck)?.length ===
                        0 && (
                        <div className="no-data data-available">
                          <img
                            src="../../img/data-not-available.png"
                            alt="data not availble"
                          />
                          <h3> {t(`mcq_manager.No Item Found`)}</h3>
                          <p>
                            {t(`mcq_manager.Sorry, we could not find any`)}
                            <br /> {t(`mcq_manager.Item to show here`)}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompetencyCategoryList;
